import { useMemo } from "react";

import usePublisherEarnings from "./use-publisher-earnings";
import useInvoiceUpload from "./use-invoice-upload";
import { getEarningsColumns } from "../misc/columns";

/**
 * Everything the earnings page renders: the breakdown rows, the Datatable
 * columns they are drawn with, and the tax invoice upload wired into the
 * action column.
 */
const useEarningsTable = (publisherId) => {
    const { loading, currency, rows, applyInvoiceDocument } = usePublisherEarnings(publisherId);
    const { inputProps, openPicker, uploadingRowId, confirmModal } = useInvoiceUpload({
        publisherId,
        onAttached: applyInvoiceDocument
    });

    const columns = useMemo(
        () => getEarningsColumns({ currency, uploadingRowId, onUpload: openPicker }),
        [currency, uploadingRowId] // eslint-disable-line react-hooks/exhaustive-deps
    );

    return {
        loading,
        rows,
        columns,
        inputProps,
        confirmModal
    };
};

export default useEarningsTable;
